import React from 'react'
import CountUp from 'react-countup'

import { VisibilitySensor } from '@icontainers/design-system/dist/atoms/VisibilitySensor'

type CounterType = {
    end: number
    separator?: string
    prefix?: string
    suffix?: string
    duration?: number
}

type CounterNumberType = ({ countUpRef }: { countUpRef: React.RefObject<HTMLElement> }) => JSX.Element
export const CounterNumber: CounterNumberType = ({ countUpRef }) => <span ref={countUpRef} />

export const Counter = ({
    end,
    separator = ',',
    prefix = '',
    suffix = ' +',
    duration = 2,
}: CounterType): JSX.Element => {
    return (
        <VisibilitySensor once>
            {({ isVisible }: { isVisible: boolean }) => (
                <CountUp
                    start={isVisible ? 0 : undefined}
                    end={end}
                    duration={duration}
                    separator={separator}
                    prefix={prefix}
                    suffix={suffix}
                >
                    {CounterNumber}
                </CountUp>
            )}
        </VisibilitySensor>
    )
}
